module.exports = __webpack_public_path__ + "img/phone.c3d8093c.svg";